import React from 'react'
import Item from '../item'
import Masonry from 'react-masonry-css'

import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import {withList} from '../../../../components/list'

export default withList(props => {
    useStyles(classes)
    const { showings, tab } = props
    return <Masonry
        breakpointCols={2}
        className={classes.MyMasonryGrid}
        columnClassName={classes.MyMasonryGridColumn}>
        {
            showings?.map((showing, index) => <Item key={index} showing={showing} sensors={{position:index+1, tab:tab}} />)
        }
    </Masonry>
})